export enum IdentificationRequestStatusTips {
	new,
	pending,
	responded,
	success,
	not_found,
	unauthorized,
	forbidden,
	gateway,
	failed,
	other,
	weak_security
}
